import { Navigate, Outlet } from "react-router-dom";
import { useAuthContext } from "../context/authContext";
import Header from "../components/Header";
import Footer from "../components/Footer";

import { FaWhatsapp } from "react-icons/fa";

function PublicRoute() {
  const { user } = useAuthContext();

  if (user) {
    return <Navigate to="/dashboard" />;
  }

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      <a
        href="https://api.whatsapp.com/send?phone=5492241492969&text=Hola%Claudia,%20quisiera%20realizar%20una%20consulta,%20Gracias!"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-5 right-5 bg-primary text-white p-3 rounded-full shadow-lg hover:opacity-80 transition-colors z-50"
        aria-label="Enviar mensaje a través de WhatsApp"
      >
        <FaWhatsapp className="h-10 w-10" />
      </a>
    </div>
  );
}

export default PublicRoute;
